exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ba4W{text-align:left;outline:none!important;text-decoration:none!important;color:#333;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-webkit-column-gap:5px;-moz-column-gap:5px;column-gap:5px}._2hJVZ{height:550px;width:100%;background-position:50%;background-repeat:no-repeat;background-size:contain}@media (max-width:575.98px){._2hJVZ{height:250px}}._33O43{height:60px;background-position:50%;background-repeat:no-repeat;background-size:cover}@media (max-width:575.98px){._33O43{height:45px}}", ""]);

// exports
exports.locals = {
	"fullscreen_button": "_2ba4W",
	"original": "_2hJVZ",
	"thumbnail": "_33O43"
};